<template>
	<div class="border-top">
		<SOFilterTitle :title="title" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOFilterSelectSkeleton v-if="pageSetting.loading"/>
			<SOInputSelect
				v-if="!pageSetting.loading"
				:title="'Mesin'"
				:selected="filterItem.mesinSnap"
				:placeholder="'Pilih jenis data yang diekspor'"
				:options="options"
				@option-selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterSelectSkeleton from "@/so-components/global/filter/skeleton/SOFilterSelectSkeleton";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";

export default {
	name: "SOFilterMesinSnap",
	components: {
		SOFilterTitle,
		SOFilterSelectSkeleton,
		SOInputSelect,
	},
	props: {
		id: String,
		title: {
			type: String,
			default: "Mesin Yang Digunakan",
		},
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
		...mapGetters("metaModule", {
			mesin: "getMesinAll"
		}),
	},
	data() {
		return {
			pageSetting: {
				loading: true,
			},
			options: [],
			diterapkan: false,
		}
	},
	watch: {
		"filterItem.outlet": {
			handler: function () {
				this.getMesinAll()
			},
			deep: true,
			immediate: true
		},
	},
	mounted() {
		if (this.title === "") {
			this.title = "Mesin Yang digunakan"
		}
		this.diterapkan = this.filterItem.mesinSnap !== ""
		this.getMesinAll()
	},

	methods: {
		async getMesinAll() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("metaModule/fetchMesinAll")
			this.pageSetting.loading = false
			if (res.success) {
				this.options = []
				this.mesin.forEach(v => {
					this.options = [
						...this.options, {
							id: v.id,
							text: v.nama,
						},
					]
				})
			} else {
				this.$toast.error(res.err)
			}
		},
		selected(val) {
			let temp = this.filterItem
			temp.mesinSnap = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.mesinSnap !== ""
		}
	}
}
</script>